<main class="row align-items-center ">
  <div class="col-11">
      <h1 class="h2 mb-0 text-truncate" >Documents</h1>
  </div>
  <app-data-table [defaultSortBy]="'preventSort'" [tableCategory]="'frontfacing document'" [showMenu]="true" class="w-100 left-0"
      [columnList]="listOfColumn" [dataSet]="blocks" [optionList]="optionList" [showLoader]="documentLoader">
  </app-data-table>    
</main>
